import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatModifyDate } from "../../components/Common/CommonLogic";
import { QueriesColVal } from "../Sales/partials/SalesCol";
import { MyBookingsLeadsBreadcrumb } from "../../common/data/parties";
import StatsSummary from "../../components/GlobalComponent/StatsSummaryComponent";
import FilterSalesInquiryComp from "../Sales/partials/FilterSalesInquiryComp";
import Page from "../../components/GlobalComponent/PageComponent";
import ViewDetails from "./modal/ViewDetails";
import { SMART_QUOTATION_VALUE_UPDATE } from "../../store/InstantRate/actionType";
import MyBookingTable from "./component/MyBookingTable";
import PriceBreakDownModal from "../../components/GlobalComponent/PriceBreakDownModal";
import { getMyBookingRequestData } from "../../store/InstantRate/actions";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { edit_icon, eye_icon } from "../../assets/images";
import { CheckCheck, CircleSlash, CircleX, CloudUpload, MailPlus, Plus } from "lucide-react";
import { QUOTE_MODAL_INITIAL } from "../../store/Sales/Quotation/actiontype";
import { getTenantQuotationSummeryById } from "../../store/Sales/actions";
import BookingAction from "./modal/BookingAction";

const BookingLeads = () => {
    document.title = "Booking Leads || Navigating Freight Costs with Precision||Ultimate Rate Management platform"

    const { instantBookingRequestData, instantBookingRequestLoader } = useSelector((state) => state?.instantRate);
    const [isRight, setIsRight] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const navigate = useNavigate();
    const [isPriceBreakDownModalOpen, setIsPriceBreakDownModalOpen] = useState(false);
    const [show, setShow] = useState(false);
    const tableRef = useRef(null);
    const [rowData, setRowData] = useState(null);
    const boxRef = useRef(null);
    const dispatch = useDispatch();
    const [isViewDetailsOpen, setIsViewDetailsOpen] = useState(false);
    const [bookingId, setBookingId] = useState(null);
    const [inquiriesId, setInquiriesId] = useState();
    const [inquiriesType, setInquiriesType] = useState();
    const [quotationData, setQuotationData] = useState(null);
    const [requestAction, setRequestAction] = useState(false);
    const [actionType, setActionType] = useState('');
    const [locationFrom] = useState('bookingLead');
    const [quotationId, setQuotationId] = useState("");

    const inputArr = {
        org_port: '',
        dest_port: '',
        status: '',
        valid_from: '',
        valid_to: '',
        customer: '',
        sales_employee: '',
        isExcelGenerated: false
    }
    const [filterDetails, setfilterDetails] = useState(inputArr);

    const toggleRightCanvas = () => {
        setIsRight(!isRight);
    };

    const constructUrl = (page, filters) => {
        let url = `?page=${page}&size=${filterDetails?.isExcelGenerated ? inquiry_data?.totalElements : 10}&`;
        url += `${filters?.customer?.id ? `customers=${filters?.customer.id}&` : ''}`;
        url += `${filters?.org_port?.id ? `origins=${filters?.org_port.id}&` : ''}`;
        url += `${filters?.dest_port?.id ? `destinations=${filters?.dest_port.id}&` : ''}`;
        url += `${filters?.sales_employee?.id ? `salesEmployees=${filters?.sales_employee.id}&` : ''}`;
        url += `${filters?.valid_from ? `validFrom=${filters?.valid_from}&` : ''}`;
        url += `${filters?.valid_to ? `validTo=${filters?.valid_to}&` : ''}`;
        url += `${filters?.status?.id ? `status=${filters?.status?.id}&` : ''}`;
        url += `${filters?.container_type?.id ? `containerType=${filters?.container_type?.id}&` : ''}`;
        url += `${filterDetails?.isExcelGenerated ? `isExcelGenerated=${true}&` : ''}`;
        url += 'requestForRates=false&';
        return url.substring(0, url.length - 1); // Remove trailing '&'
    };

    const applyFilterHandler = () => {
        setIsRight(false);
        filterDetails.isExcelGenerated = false;
        let url = constructUrl(currentPage, filterDetails);
        dispatch(getNetworkInquiriesSummary(false));
    };

    const clearValueHandler = () => {
        setfilterDetails(inputArr);
        let url = constructUrl(currentPage, {});
        //dispatch(getSalesInquiryData(url));
    };

    useEffect(() => {
        dispatch({
            type: SMART_QUOTATION_VALUE_UPDATE,
            payload: { quote_currency: { value: 'US DOLLAR', label: 'USD', currencyCode: 'USD', id: 3, version: 0 } },
        });

        //let url = constructUrl(currentPage, filterDetails);
        if (currentPage !== '' && currentPage !== undefined) {
            let url = `?isMyBookings=false&page=${currentPage}&size=10`;
            dispatch(getMyBookingRequestData(url));
        }
        console.log("hit this");
    }, [dispatch, currentPage]);

    const downLoadExcelReport = () => {
        filterDetails.isExcelGenerated = true;
        let url = constructUrl(currentPage, filterDetails);
        //dispatch(getSalesInquiryData(url));
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (boxRef.current && !boxRef.current.contains(event.target)) {
                setShow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [boxRef]);

    const handleClose = () => {
        setShow(false);
    }

    const handleOnSellerIdClick = (sellerId, rowRect) => {
        //dispatch(getQuotationSellerListById(sellerId));
        setRowData(rowRect)
    }

    const viewBids = (data) => {
        console.log(data);
        navigate('/view/bids', {
            state: {
                data: data
            },
        });
    };

    const toggleViewDetails = () => {
        setIsViewDetailsOpen(!isViewDetailsOpen);
    }

    const viewDetails = (objData) => {
        setInquiriesType(objData?.rateType || "")
        setInquiriesId(objData?.inquiryId);
        setBookingId(objData?.bookingSummeryId || null);
        toggleViewDetails();
    }

    const QuoteModalHandler = (data) => {
        console.log(data, "data");
        setQuotationId(data?.quotationId);
        setInquiriesType(data?.rateType || "")
        priceBreakDownModalHandler();
        dispatch(getTenantQuotationSummeryById(data?.quotationId));
    }

    const priceBreakDownModalHandler = () => {
        setIsPriceBreakDownModalOpen(!isPriceBreakDownModalOpen);
    }

    const applyBids = (data) => {
        dispatch({ type: QUOTE_MODAL_INITIAL });
        navigate('/apply/quotation/bids', {
            state: {
                inquiriesId: data?.inquiryId,
                data: data,
                locationFrom: 'bookingLeads'
            },
        });
    };

    const reqestAction = (dataObj, actionType) => {
        setQuotationData(dataObj);
        console.log(dataObj);
        setActionType(actionType);
        setRequestAction(true);
    }

    const onRefresh = () => {
        if (currentPage !== '' && currentPage !== undefined) {
            let url = `?isMyBookings=false&page=${currentPage}&size=10`;
            dispatch(getMyBookingRequestData(url));
        }
    }

    const columns = useMemo(() => [
        {
            Header: 'Inquiry Type',
            accessor: 'rateType',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{cellProps.row.original?.rateType?.replace("_", " ") || '-'}</span>
                );
            }
        },
        {
            Header: 'Booking Dt',
            accessor: 'quotationDate',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <span>{formatModifyDate(cellProps.row.original?.quotationDate)}</span>
                )
            }
        },
        {
            Header: 'Booking ID',
            accessor: 'bookingSummeryId',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Origin',
            accessor: 'originPortName',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Destination',
            accessor: 'destinationPortName',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Cargo Ready Date',
            accessor: 'cargoDate',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                const cargoDate = cellProps.row.original?.cargoDate;
                const cargoDateSplit = typeof cargoDate === "string" ? cargoDate.split('/') : [];
                return (cargoDateSplit[0] !== "" && cargoDateSplit[1] !== "") ? (
                    <span>{formatModifyDate(cargoDateSplit[0])}/{formatModifyDate(cargoDateSplit[1])}</span>
                ) : <span>/</span>;
            }
        },
        {
            Header: 'Cargo Details',
            accessor: 'cargoDetails',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <label className="form-label" onClick={(e) => {
                        e.stopPropagation();
                        viewDetails(cellProps.row.original);
                    }}>
                        <span className="align-content-center">View Details</span>
                    </label>
                )
            }
        },
        {
            Header: 'Quotation Details',
            accessor: 'quotationDetails',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return (
                    <label className="form-label" onClick={(e) => {
                        e.stopPropagation();
                        QuoteModalHandler(cellProps.row.original);
                    }}>
                        <span className="align-content-center">View Details</span>
                    </label>
                )
            }
        },
        // {
        //     Header: 'Documents',
        //     accessor: 'documents',
        //     filterable: true,
        //     disableFilters: true,
        //     Cell: (cellProps) => {
        //         return (
        //             <label className="form-label" onClick={(e) => {
        //                 e.stopPropagation();
        //                 viewDetails(cellProps.row.original);
        //             }}>
        //                 <span className="align-content-center">View Details</span>
        //             </label>
        //         )
        //     }
        // },
        {
            Header: 'Status',
            accessor: 'statusName',
            filterable: true,
            disableFilters: true,
            Cell: (cellProps) => {
                return <QueriesColVal cellProps={cellProps} />
            }
        },
        {
            Header: 'Action',
            Cell: (cellProps) => {
                return (
                    <UncontrolledDropdown>
                        <DropdownToggle className="btn btn-link text-muted py-1 font-size-16 shadow-none" tag="a">
                            <i className='bx bx-dots-vertical-rounded'></i>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            {/* Additional Charges button - disabled for CUST_APPRVD and CUST_REJECT and BOOKING_ACCEPTED */}
                            <DropdownItem
                                className={cellProps.row.original?.statusCode === 'CUST_APPRVD' || cellProps.row.original?.statusCode === 'CUST_REJECT' || cellProps.row.original?.statusCode === 'BOOKING_ACCEPTED' ? 'disabled-item' : ''}
                                disabled={cellProps.row.original?.statusCode === 'CUST_APPRVD' || cellProps.row.original?.statusCode === 'CUST_REJECT' || cellProps.row.original?.statusCode === 'BOOKING_ACCEPTED'}
                                onClick={(e) => { e.stopPropagation(); applyBids(cellProps.row.original) }}
                            >
                                Additional Charges <Plus size={18} className="me-2 text-secondary" />
                            </DropdownItem>

                            {/* Accept Booking button - disabled for CUST_REJECT and BOOKING_ACCEPTED */}
                            <DropdownItem
                                className={cellProps.row.original?.statusCode === 'CUST_REJECT' || cellProps.row.original?.statusCode === 'BOOKING_ACCEPTED' ? 'disabled-item' : ''}
                                disabled={cellProps.row.original?.statusCode === 'CUST_REJECT' || cellProps.row.original?.statusCode === 'BOOKING_ACCEPTED'}
                                onClick={(e) => { e.stopPropagation(); reqestAction(cellProps.row.original, 'accept') }}
                            >
                                Accept Booking <CheckCheck size={18} className="me-2 text-secondary" />
                            </DropdownItem>

                            {/* Reject Booking button - disabled for CUST_REJECT and BOOKING_ACCEPTED */}
                            <DropdownItem
                                className={cellProps.row.original?.statusCode === 'CUST_REJECT' || cellProps.row.original?.statusCode === 'BOOKING_ACCEPTED' ? 'disabled-item' : ''}
                                disabled={cellProps.row.original?.statusCode === 'CUST_REJECT' || cellProps.row.original?.statusCode === 'BOOKING_ACCEPTED'}
                                onClick={(e) => { e.stopPropagation(); reqestAction(cellProps.row.original, 'reject') }}
                            >
                                Reject Booking <CircleX size={18} className="me-2 text-secondary" />
                            </DropdownItem>
                            {/*  <DropdownItem onClick={(e) => { e.stopPropagation(); viewPopupHandler(cellProps.row.original) }}>Email Customer <MailPlus size={18} className="me-2 text-secondary" /></DropdownItem> */}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                )
            }
        },
    ], [instantBookingRequestData]);

    const myBookingsStatsData = [
        {
            title: 'Bookings Requested',
            value: instantBookingRequestData?.bookingsRequested,
            percentage: 0,
            rate: '',
            rateType: 'down'
        },
        {
            title: 'Bookings confirmed',
            value: instantBookingRequestData?.bookingsConfirmed,
            percentage: 0,
            rate: '',
            rateType: 'down'
        },
        {
            title: 'Bookings in Progress',
            value: instantBookingRequestData?.bookingsInProgress,
            percentage: 0,
            rate: '',
            rateType: 'up'
        },
        {
            title: 'Bookings Cancelled',
            value: instantBookingRequestData?.bookingsCancelled,
            percentage: 0,
            rate: '',
            rateType: 'down'
        }
    ];

    return (
        <>
            <Page>
                <StatsSummary
                    breadcrumb={MyBookingsLeadsBreadcrumb}
                    stats={myBookingsStatsData}
                />
                {/* Wokring Leter */}
                {/* <MyBookingsItems /> */}
                <MyBookingTable
                    tableRef={tableRef}
                    columns={columns}
                    data={!!instantBookingRequestData.content ? instantBookingRequestData.content : []}
                    isGlobalFilter={true}
                    isAddInvoiceList={true}
                    loader={instantBookingRequestLoader}
                    customPageSize={25}
                    toggleRightCanvas={toggleRightCanvas}
                    downLoadExcelReport={downLoadExcelReport}
                    component={'myBookings'}
                    setCurrentPage={setCurrentPage}
                    totalPages={instantBookingRequestData?.totalPages || 0}
                    totalEntries={instantBookingRequestData?.totalElements || 0}
                />
                <ViewDetails isOpen={isViewDetailsOpen} inquirieType={inquiriesType} inquirieId={inquiriesId} toggle={toggleViewDetails} bookingId={bookingId} />
            </Page>
            <FilterSalesInquiryComp isRight={isRight} toggleRightCanvas={toggleRightCanvas} filterDetails={filterDetails} setfilterDetails={setfilterDetails} applyFilterHandler={applyFilterHandler} clearValueHandler={clearValueHandler} />
            {isPriceBreakDownModalOpen && <PriceBreakDownModal quotationId={quotationId} isPriceBreakDownModalOpen={isPriceBreakDownModalOpen} quotationData={quotationData} priceBreakDownModalHandler={priceBreakDownModalHandler} inquiriesType={inquiriesType} />}
            {requestAction && <BookingAction actionOpen={requestAction} setActionOpen={setRequestAction} quotationData={quotationData} actionType={actionType} locationFrom={locationFrom} onRefresh={onRefresh} />}
        </>
    );
};

export default BookingLeads;
